import { Controller } from "@hotwired/stimulus"
import { sessionPresent } from "../lib/session_marker"

export default class extends Controller {
  static values = { src: String }

  connect() {
    if (this.element.hasAttribute("src") || !sessionPresent()) return

    this.element.setAttribute("src", this.srcValue)
  }
}
